import React from 'react';

import { Button } from '@/components/ui/button';

interface SitemapActionsProps {
  onShowAll: () => void;
  onCollapseAll: () => void;
}

/**
 * The "Actions:" row (Show all / Collapse all). Rendered inside
 * `TableControlsContainer.selectionBar` so it sits below the divider, matching
 * the Assets page two-tier layout.
 */
export const SitemapActions: React.FC<SitemapActionsProps> = ({
  onShowAll,
  onCollapseAll,
}) => (
  <div className="flex flex-wrap items-center gap-2 px-4 py-3">
    <h2 className="shrink-0 text-sm font-bold">Actions:</h2>
    <Button
      variant="outline"
      size="sm"
      className="rounded-full"
      onClick={onShowAll}
    >
      Show all
    </Button>
    <Button
      variant="outline"
      size="sm"
      className="rounded-full"
      onClick={onCollapseAll}
    >
      Collapse all
    </Button>
  </div>
);
